import {useEffect, useRef} from 'react'

import {FINANCING_INTENTION_ID} from '../ContactForm/BuyerIntentions.js'
import {V2_FIELDS} from '../schema/contactSchema.js'

export const useBuyerIntentionsRestore = ({initialBuyerIntentions, form, onBuyerIntentionsChange}) => {
  const hasInitializedBuyerIntentions = useRef(false)

  useEffect(() => {
    if (hasInitializedBuyerIntentions.current || !initialBuyerIntentions?.length) {
      return
    }

    hasInitializedBuyerIntentions.current = true
    form.setFieldValue(V2_FIELDS.BUYER_INTENTIONS, initialBuyerIntentions)
    onBuyerIntentionsChange?.({
      selectedBuyerIntentions: initialBuyerIntentions,
      hasFinancingIntention: initialBuyerIntentions.includes(FINANCING_INTENTION_ID)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialBuyerIntentions])
}

export default useBuyerIntentionsRestore
